const categorySelectionPageUrl = '/categories/';
const brandSelectionPageUrl = '/brands/';

const baseFitmentFields = ['Year', 'Make', 'Model', 'Application'];
const extraFitmentFields = [];

const isCategoryPage = window.location.pathname.includes('/product-category/');
const isCategorySelectionPage = window.location.pathname === categorySelectionPageUrl;

window.Convermax.toogleSearchBoxPopdown = (e) => {
  e.preventDefault();
  e.stopPropagation();
  const popdownRoot = e.currentTarget?.closest('.cm_search-box-root__popdown');
  const popdownContent = popdownRoot?.querySelector('.cm_search-box-root__popdown-content');
  if (!popdownContent) {
    return;
  }

  const isOpening = popdownContent.classList.contains('cm_hide');
  popdownContent.classList.toggle('cm_hide');

  if (isOpening) {
    const header = document.querySelector('#header');
    if (header) {
      popdownContent.style.top = `${header.getBoundingClientRect().bottom}px`;
    }
    popdownRoot?.querySelector('.cm_searchInput')?.focus();
  }
};

window.Convermax.addToCart = (e) => {
  e.preventDefault();

  const button = e.target;
  if (!button.getAttribute('data-product_id')) {
    return true;
  }

  const data = {};
  for (const attr of button.attributes) {
    if (attr.name.startsWith('data-')) {
      data[attr.name.slice(5)] = attr.value;
    }
  }
  const event = new CustomEvent('adding_to_cart', { detail: { button, data } });
  document.body.dispatchEvent(event);

  ajaxAddToCart({
    type: 'POST',
    url: 'autoparts/?wc-ajax=add_to_cart',
    data,
    success: (response) => {
      if (!response) {
        return;
      }

      if (response.error && response.product_url) {
        window.location = response.product_url;
        return;
      }

      const viewCartButton = button.parentElement.querySelector('.added_to_cart');
      if (viewCartButton) {
        viewCartButton.classList.remove('cm_hide');
      }

      const addedEvent = new CustomEvent('added_to_cart', {
        // eslint-disable-next-line camelcase
        detail: { fragments: response.fragments, cart_hash: response.cart_hash, button },
      });
      document.body.dispatchEvent(addedEvent);
    },
    dataType: 'json',
  });
};

function ajaxAddToCart(options) {
  const xhr = new XMLHttpRequest();

  xhr.open(options.type, options.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  xhr.onload = function () {
    if (xhr.status === 200) {
      options.success(JSON.parse(xhr.responseText));
    } else if (options.error) {
      options.error(xhr);
    }
  };
  xhr.onerror = options.error;

  xhr.send(
    Object.keys(options.data)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(options.data[key])}`)
      .join('&'),
  );
}

function getLocalPreselection() {
  if (isCategoryPage && window.cm_category) {
    return [
      {
        field: 'categories',
        term: window.cm_category,
        treeLevel: window.cm_category.length - 1,
      },
    ];
  }

  return null;
}

export default {
  platform: 'woocommerce',
  searchPageUrl: '/search/',
  getLocalPreselection,
  sortFields: ['relevance', 'total_sales:desc', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  product: {
    noImageSrc: '/wp-content/uploads/woocommerce-placeholder-398x398.png',
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'categories' },
      { pathname: brandSelectionPageUrl, field: 'brand' },
    ],
    categorySelectionPageRedirect: true,
  },
  page: {
    getPageType: (defaults) =>
      isCategorySelectionPage ? 'parts' : isCategoryPage ? 'category' : defaults.getter(),
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: {
        replace: 'body.tax-product_cat #main .container .row',
      },
      template: 'SearchPage',
    },
    // keep 'hide' class to prevent 'select2' third-party script from initializing
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select form-select--small hide',
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchBox',
      location: {
        insertBefore: '#header .axm-header-cart',
        class: 'cm_search-box-root__desktop cm_search-box-root__popdown cm_mobile-hide',
      },
      template: 'DesktopSearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertBefore: '#header .axm-header-cart',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '#header .axm-header-cart',
        class: 'cm_garage__container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.product-template-default .entry-summary .prod-add-to-cart',
      },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => isCategorySelectionPage,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: 'body.home .wcmap-part-filter',
      template: 'fitmentSearch/homeVehicleWidget',
      isAlwaysActive: true,
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: 'body.product-template-default .woocommerce-tabs li:first-child',
        wrapper: 'li',
        id: 'tab-title-fitment',
        class: 'fitment_tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FitmentTable',
      location: {
        insertAfter: 'body.product-template-default .woocommerce-Tabs-panel:first-of-type',
      },
      template: 'fitmentSearch/fitmentTableTabContent',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
      initCollapsed: true,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
